import { Component } from '@angular/core';

@Component({
  selector: 'plant-management-layout',
  templateUrl: './plant-management.layout.html',
  styleUrls: ['./plant-management.layout.scss'],
})
export class PlantManagementLayoutComponent {
  public lastAction = 'No action yet';

  public onCreatePlant(): void {
    this.lastAction = 'Create Plant';
  }

  public onRefresh(): void {
    this.lastAction = 'Refresh';
  }

  public onExport(): void {
    this.lastAction = 'Export';
  }
}
